/* eslint-disable no-restricted-imports */
import { CSSProperties } from '@mui/material/styles/createTypography';
import { TypographyVariants } from './types';
import {
  Header, Body, Label, Subtitle, Utility,
} from './variants';

export const variantMapping: Record<TypographyVariants | 'inherit', string> = {
  h1: Header.variants.h1.tag,
  h2: Header.variants.h2.tag,
  h3: Header.variants.h3.tag,
  h4: Header.variants.h4.tag,
  h5: Header.variants.h5.tag,
  h6: Header.variants.h6.tag,

  subtitle1: Subtitle.variants.subtitle1.tag,
  subtitle2: Subtitle.variants.subtitle2.tag,

  body1: Body.variants.body1.tag,
  body2: Body.variants.body2.tag,
  body3: Body.variants.body3.tag,

  label1: Label.variants.label1.tag,
  label2: Label.variants.label2.tag,
  label3: Label.variants.label3.tag,

  link1: Utility.variants.link1.tag,
  link2: Utility.variants.link2.tag,
  link3: Utility.variants.link3.tag,

  mono1: Utility.variants.mono1.tag,
  mono2: Utility.variants.mono2.tag,
  mono3: Utility.variants.mono3.tag,

  inherit: 'p',
};

export const Typography = {
  h1: Header.variants.h1.styles,
  h2: Header.variants.h2.styles,
  h3: Header.variants.h3.styles,
  h4: Header.variants.h4.styles,
  h5: Header.variants.h5.styles,
  h6: Header.variants.h6.styles,
  subtitle1: Subtitle.variants.subtitle1.styles,
  subtitle2: Subtitle.variants.subtitle2.styles,
  body1: Body.variants.body1.styles,
  body2: Body.variants.body2.styles,
  button: {
    ...Label.variants.label2.styles,
    textTransform: 'none',
  } as CSSProperties,
  caption: Subtitle.variants.subtitle1.styles,
  overline: Body.variants.body3.styles,

  // CXN custom
  body3: Body.variants.body3.styles,

  label1: Label.variants.label1.styles,
  label2: Label.variants.label2.styles,
  label3: Label.variants.label3.styles,

  link1: Utility.variants.link1.styles,
  link2: Utility.variants.link2.styles,
  link3: Utility.variants.link3.styles,
  mono1: Utility.variants.mono1.styles,
  mono2: Utility.variants.mono2.styles,
  mono3: Utility.variants.mono3.styles,
};
